import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChairModern: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChairModern"><Path d="M19 14.5L16.3077 2.5H7.69231L5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 14.5C14.125 16 9.875 16 3.5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 15.5L5.5 21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 15.5L18.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChairModern;
